module.exports = __webpack_public_path__ + "static/custom_projects_luxo-30a079e6d5ade43086869307769bd06f.svg";